module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-64.5e8332d.woff2";